import VueRouter from 'vue-router'
import store from 'store'

import Index from '../pages/Index'
import Pay from '../pages/Pay'
import Result from '../pages/Result'

const router = new VueRouter({
  // mode: 'history',
  routes: [{
    path: '/',
    component: Index,
  }, {
    path: '/pay',
    component: Pay,
    beforeEnter: (to, from, next) => {
      const production = store.production
      if (!production) {
        router.replace('/')
        return
      }

      next()
    },
  }, {
    path: '/result',
    component: Result,
    beforeEnter: (to, from, next) => {
      const query = to.query || {}
      if (!query.out_trade_no) {
        router.replace('/')
        return
      }

      next()
    },
  }, {
    path: '*',
    redirect: '/',
  }],
})

export default router



// WEBPACK FOOTER //
// ./src/routes/index.js